module.exports = __webpack_public_path__ + "static/media/instructor_code.249e5f5e.jpg";